import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeSalaryLoanInstalment  {
    _originalTypeClassName = "zERP.BO.EmployeeSalaryLoanInstalment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeSalaryLoanInstalment.translate = translateService;
}
this.Id = null;
this.Index = null;
this.Amount = null;
this.IsPaid = false;
this.isCashPaid = false;
this.CashPaidDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Index:any;
Amount:any;
IsPaid:any;
isCashPaid:any;
CashPaidDate:any;
EmployeeSalaryLoan:any;
SalaryPeriod:any;
PayrollPeriod:any;
PayedOn:any;
static setEmployeeSalaryLoan = ($this, value) => {
var oldValue = $this.EmployeeSalaryLoan;
$this.EmployeeSalaryLoan = value;
if (value != null) {
if (oldValue != null) {
Domain.EmployeeSalaryLoan.removeInstalments(oldValue, $this);
}
Domain.EmployeeSalaryLoan.addInstalments(value, $this);
}
}
static setSalaryPeriod = ($this, value) => {
var oldValue = $this.SalaryPeriod;
$this.SalaryPeriod = value;
if (value != null) {
}
}
static setPayrollPeriod = ($this, value) => {
var oldValue = $this.PayrollPeriod;
$this.PayrollPeriod = value;
if (value != null) {
}
}
static setPayedOn = ($this, value) => {
var oldValue = $this.PayedOn;
$this.PayedOn = value;
if (value != null) {
if (oldValue != null) {
Domain.EmployeePayroll.removeLoanInstalments(oldValue, $this);
}
Domain.EmployeePayroll.addLoanInstalments(value, $this);
}
}

static Payed($this: any, payroll: any): any{Domain.EmployeeSalaryLoanInstalment.setPayedOn($this, payroll);
$this.IsPaid = true;
Domain.EmployeeSalaryLoan.UpdateRemainingData($this?.EmployeeSalaryLoan);
}
static Unpay($this: any): any{Domain.EmployeeSalaryLoanInstalment.setPayedOn($this, null);
$this.IsPaid = true;
Domain.EmployeeSalaryLoan.UpdateRemainingData($this?.EmployeeSalaryLoan);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}